import { Link } from "react-router-dom";
import { ReactNode } from "react";

interface LegalPageLayoutProps {
  title: string;
  effectiveDate: string;
  version: string;
  children: ReactNode;
}

const LegalPageLayout = ({ title, effectiveDate, version, children }: LegalPageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border">
        <div className="mx-auto max-w-3xl px-6 py-5 flex items-center justify-between">
          <Link to="/" className="font-semibold tracking-tight">Wavlynq</Link>
          <nav className="flex gap-4 text-sm text-muted-foreground">
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/cookies" className="hover:text-foreground transition-colors">Cookies</Link>
            <Link to="/ai-policy" className="hover:text-foreground transition-colors">AI Use</Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-12">
        <div className="mb-10 border-b border-border pb-6">
          <h1 className="text-3xl font-bold tracking-tight mb-3">{title}</h1>
          <p className="text-sm text-muted-foreground">
            <span className="font-medium text-foreground">Effective:</span> {effectiveDate}
            <span className="mx-2">•</span>
            <span className="font-medium text-foreground">Version:</span> {version}
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            Operated by Young's Digital Atelier LLC, a subsidiary of Young's Multimedia Holdings LLC.
          </p>
        </div>

        <article className="prose prose-neutral dark:prose-invert max-w-none
          prose-headings:scroll-mt-24
          prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4 prose-h2:font-semibold
          prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2 prose-h3:font-semibold
          prose-p:leading-relaxed prose-p:text-foreground/90
          prose-li:text-foreground/90
          prose-strong:text-foreground prose-strong:font-semibold
          prose-a:text-primary prose-a:no-underline hover:prose-a:underline">
          {children}
        </article>

        <footer className="mt-16 pt-8 border-t border-border text-sm text-muted-foreground space-y-2">
          <p className="font-medium text-foreground">Young's Digital Atelier LLC</p>
          <p>702 Richland Hills Dr #760866, San Antonio, TX 78245, USA</p>
          <p>
            <a href="mailto:support@wavlynq.com">support@wavlynq.com</a>
            <span className="mx-2">•</span>
            <a href="mailto:privacy@wavlynq.com">privacy@wavlynq.com</a>
            <span className="mx-2">•</span>
            <a href="mailto:legal@wavlynq.com">legal@wavlynq.com</a>
            <span className="mx-2">•</span>
            <a href="mailto:dmca@wavlynq.com">dmca@wavlynq.com</a>
          </p>
        </footer>
      </main>
    </div>
  );
};

export default LegalPageLayout;
